import { ConsignmentStockOutListPage } from "@/features/consignment-stock-out/pages/ConsignmentStockOutListPage";
import { createFileRoute } from "@tanstack/react-router";

// List stays mounted under detail.
export const Route = createFileRoute("/vendor/consignment-stock-out")({
	component: ConsignmentStockOutListPage,
});
